<template>
    <v-main>
        <v-container>
            <v-row v-if="step == 5">
                <v-col cols="12" md="12" class="ma-0 d-flex justify-center">
                    <div id="yellow-chip">
                        <label
                            class="
                                prompt-
                                d-flex
                                justify-center
                                text-center
                                pt-2
                            "
                            >{{$t("message.form.topics.formWarningContent")}}</label
                        >
                    </div>
                </v-col>
            </v-row>
            <v-row id="step5-all-form">
                <v-col cols="12" sm="12" md="7">
                    <div class="d-flex justify-md-end justify-sm-center">
                        <StudentHistory
                            ref="student_detail"
                            @formValidate="validateStudentDetail"
                            :checkValidate="user.clickable"
                            :callAutoFill="user.fill"
                            :stepActive="step"
                            :registrationFormDetail="registrationFormDetail"
                            :registrationState="registrationState"
                            :student_id="student_id"
                            @targetStudentYear="getTargetStudentYear"
                            @loadingUpdate="loadingUpdate"
                            @changeStudentNameTh="changeStudentNameTh"
                            @changeStudentNameEn="changeStudentNameEn"
                            v-if="registrationFormDetail"
                        />
                    </div>
                    <div class="my-5 d-flex justify-md-end justify-sm-center">
                        <StudentAddress
                            ref="student_address_detail"
                            @formValidate="validateStudentAddressDetail"
                            :checkValidate="user.clickable"
                            :callAutoFill="user.fill"
                            :stepActive="step"
                            :registrationState="registrationState"
                            @loadingUpdate="loadingUpdate"
                        />
                    </div>
                    <div class="my-5 d-flex justify-md-end justify-sm-center">
                        <StudentParent
                            ref="student_parent"
                            @formValidate="validateStudentParent"
                            :checkValidate="user.clickable"
                            :callAutoFill="user.fill"
                            :stepActive="step"
                            :registrationState="registrationState"
                            @loadingUpdate="loadingUpdate"
                        />
                    </div>
                    <div class="my-5 d-flex justify-md-end justify-sm-center">
                        <StudentEducation
                            ref="student_other_detail"
                            @formValidate="validateStudentOtherDetail"
                            :checkValidate="user.clickable"
                            :callAutoFill="user.fill"
                            :targetStudentYear="targetStudentYear"
                            :stepActive="step"
                            :registrationState="registrationState"
                            @loadingUpdate="loadingUpdate"
                        />
                    </div>
                    <div class="my-5 d-flex justify-md-end justify-sm-center">
                        <StudentHealth
                            :stepActive="step"
                            :registrationState="registrationState"
                            ref="student_health_detail"
                            @sendData="getStudentHealthDetail"
                            @loadingUpdate="loadingUpdate"
                        />
                    </div>
                    <div class="my-5 d-flex justify-md-end justify-sm-center">
                        <StudentEvidence
                            ref="student_document"
                            :stepActive="step"
                            :registrationState="registrationState"
                            :registrationFormDetail="registrationFormDetail"
                            :extraDocuments="registrationFormDetail.register_documents_setting"
                            :student_id="student_id"
                            :studentFullNameTh="studentFullNameTh"
                            :studentFullNameEn="studentFullNameEn"
                            v-if="registrationFormDetail"
                            @loadingUpdate="loadingUpdate"
                        />
                    </div>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="5"
                    id="step-sidebar"
                    class="ma-0 px-0"
                >
                    <StudentForm
                        ref="student_form"
                        :clickable="user.clickable"
                        :checkAutoFill="user.fill"
                        @masterAutoFilled="user.fill = !user.fill"
                        @changeClickable="
                            user.clickable = !user.clickable;
                            containerData();
                        "
                        :registrationFormDetail="registrationFormDetail"
                        v-if="registrationFormDetail"
                        :checkValidateForm="checkValidateFormCompute"
                        :step="step"
                        :result_type="result_type"
                        @loadingUpdate="loadingUpdate"
                    />
                </v-col>
                <v-col cols="12" sm="12" md="5" class="ma-0 px-0">
                    <div style="height: 480px" id="height-overflow"></div>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>
<script>
import StudentForm from "./formPartial/StudentForm";
import StudentHistory from "./formPartial/StudentHistory";
import StudentAddress from "./formPartial/StudentAddress";
import StudentParent from "./formPartial/StudentParent";
import StudentEducation from "./formPartial/StudentEducation";
import StudentEvidence from "./formPartial/StudentEvidence";
import StudentHealth from "./formPartial/StudentHealth";

export default {
    name: "FormData",
    components: {
        StudentForm,
        StudentHistory,
        StudentAddress,
        StudentParent,
        StudentEducation,
        StudentEvidence,
        StudentHealth,
    },
    data() {
        return {
            email: "",
            user: {
                clickable: false,
                fill: false,
            },
            type: "pass",
            student_detail: {},
            student_address: {},
            student_parent: {},
            student_other_detail: {},
            student_health_detail: {},
            checkValidateForm: false,
            form: {
                student_detail: false,
                student_address_detail: false,
                student_parent: false,
                student_other_detail: false,
            },
            targetStudentYear: 0,
            submit: true,
            studentFullNameTh: "",
            studentFullNameEn: "",
        };
    },
    methods: {
        loadingUpdate(value) {
            this.$emit("loadingUpdate", value);
        },
        getTargetStudentYear(value) {
            this.targetStudentYear = value;
        },
        validateStudentDetail(value) {
            this.form.student_detail = value;
        },
        validateStudentOtherDetail(value) {
            this.form.student_other_detail = value;
        },
        validateStudentParent(value) {
            this.form.student_parent = value;
        },
        validateStudentAddressDetail(value) {
            this.form.student_address_detail = value;
        },
        getStudentHealthDetail(value) {
            this.student_health_detail = value;
        },
        async containerData() {
            if (this.validateForm()) {
                const refBody = {
                    student_detail:
                        this.$refs?.student_detail?._data?.student_detail,
                    student_address_detail:
                        this.$refs?.student_address_detail?._data
                            ?.student_address_detail,
                    student_other_detail:
                        this.$refs?.student_other_detail?._data
                            ?.student_other_detail,
                    student_parent: this.$refs?.student_parent?._data,
                    student_parent_address: {
                        father: {},
                        mother: {},
                        guardian: {},
                    },
                };
                if (this.step == 5) {
                    refBody.student_other_detail = {
                        ...refBody.student_other_detail,
                        ...this.student_health_detail,
                    };

                    const student_parent = this.$refs?.student_parent;
                    if (!student_parent?._data?.father?.is_same_student_address) {
                        const address =
                            student_parent?.$refs?.fatherAddress?._data
                                ?.parentAddress;
                        refBody.student_parent_address.father = {
                            ...refBody.student_parent_address.father,
                            ...address,
                            is_same_student_address: false,
                        };
                    } else {
                        const address = refBody.student_address_detail;
                        refBody.student_parent_address.father = {
                            address: address.current_address,
                            province: address.current_province,
                            district: address.current_district,
                            subdistrict: address.current_subdistrict,
                            postal_code: address.current_postal_code,
                            is_same_student_address: true,
                        };
                    }
                    if (!student_parent?._data?.mother?.is_same_student_address) {
                        const address =
                            student_parent?.$refs?.motherAddress?._data
                                ?.parentAddress;
                        refBody.student_parent_address.mother = {
                            ...refBody.student_parent_address.mother,
                            ...address,
                            is_same_student_address: false,
                        };
                    } else {
                        const address = refBody.student_address_detail;
                        refBody.student_parent_address.mother = {
                            address: address.current_address,
                            province: address.current_province,
                            district: address.current_district,
                            subdistrict: address.current_subdistrict,
                            postal_code: address.current_postal_code,
                            is_same_student_address: true,
                        };

                    }
                    if (!student_parent?._data?.guardian?.is_same_student_address) {
                        const address =
                            student_parent?.$refs?.guardianAddress?._data
                                .parentAddress;
                        refBody.student_parent_address.guardian = {
                            ...refBody.student_parent_address.guardian,
                            ...address,
                            is_same_student_address: false,
                        };
                    } else {
                        const address = refBody.student_address_detail;
                        refBody.student_parent_address.guardian = {
                            address: address.current_address,
                            province: address.current_province,
                            district: address.current_district,
                            subdistrict: address.current_subdistrict,
                            postal_code: address.current_postal_code,
                            is_same_student_address: true,
                        };
                    }
                }
                const student_detail = setStudentDetail(
                    refBody.student_detail,
                    this.step
                );
                const student_other_detail = setStudentOtherDetail(
                    refBody.student_other_detail,
                    this.step
                );
                const student_address_detail = setStudentAddress(
                    refBody.student_address_detail,
                    this.step
                );
                const student_parent = setStudentParent(
                    refBody.student_parent,
                    refBody.student_parent_address,
                    this.step
                );
                const body = {
                    student_detail: student_detail,
                    student_address_detail: student_address_detail,
                    student_other_detail: student_other_detail,
                };
                if (refBody.student_parent.hasMother) {
                    body["mother"] = student_parent.mother;
                }
                if (refBody.student_parent.hasFather) {
                    body["father"] = student_parent.father;
                }
                if (!refBody.student_parent.toggleDisableGuardian) {
                    body["guardian"] = student_parent.guardian;
                }
                if (this.step == 5) {
                    body["student_parent_detail"] =
                        student_parent.student_parent_detail;
                    body["registration_status"] =
                        RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL;
                } else {
                    body["student_parent_detail"] =
                        student_parent.student_parent_detail;
                    if (this.registrationFormDetail.fee == 0 || this.registrationFormDetail.fee == null || this.registrationFormDetail?.fee == undefined) {
                        body["registration_status"] =
                            RegistrationStatusEnum.REGISTER;
                    } else {
                        body["registration_status"] =
                            RegistrationStatusEnum.PENDING_PAYMENT;
                    }
                }

                body["step"] = this.step;

                if (this.submit) {
                    let isCompleted = true;
                    try {
                        this.submit = false
                        this.loadingUpdate(1);

                        // upload student picture
                        if(student_detail.student_img != null){
                            await services.uploadStudentPicture(student_detail.student_img.body, {
                                module: student_detail.student_img.module,
                                fileName: student_detail.student_img.fileName,
                                student_id: student_detail.student_img.student_id,
                            });
                        }

                        if(this.step == 1){
                            // upload document files
                            await this.$refs?.student_document?.uploadToServer()
                            isCompleted = this.$refs?.student_document?.isUploadToServer
                        }

                        const res = await services.updateStudentApplicationForm(
                            body,
                            this.student_id
                        );
                        if (res.status == 200 && isCompleted) {
                            location.reload();
                        }
                    } catch (err){
                        console.error(err);
                    } finally {
                        this.submit = true
                        this.loadingUpdate(-1);
                    }
                }
            }
        },
        validateForm() {
            const student_detail_form =
                this.$refs?.student_detail?.validate();
            const student_address_form =
                this.$refs?.student_address_detail?.$refs?.form?.validate();
            const student_parent_form =
                this.$refs?.student_parent?.$refs?.form?.validate();
            const student_other_detail_form =
                this.$refs?.student_other_detail?.$refs?.form?.validate();
            const student_document =
                this.$refs?.student_document?.isUploadComplete || this.step == 5;
            return (
                student_address_form &&
                student_detail_form &&
                student_parent_form &&
                student_other_detail_form &&
                (this.$refs?.student_form?._data?.is_consent || this.step == 5) &&
                (student_document)
            );
        },
        changeStudentNameTh(value) {
            this.studentFullNameTh = value
        },
        changeStudentNameEn(value) {
            this.studentFullNameEn = value
        }
    },
    props: {
        step: Number,
        student_id: Number,
        registrationFormDetail: Object,
        registrationState: String,
        result_type: String,
    },
    computed: {
        checkValidateFormCompute() {
            const validate =
                this.form.student_address_detail &&
                this.form.student_other_detail &&
                this.form.student_parent &&
                this.form.student_detail;
            let student_document = true
            if(this.step == 1){
                student_document =
                    this.$refs?.student_document?.isUploadComplete;
            }
            return validate && student_document;
        }
    },
    updated() {
        this.checkValidateFormCompute;
    },
};
import * as services from "@/services";
import { RegistrationStatusEnum } from "@/constants";

const setStudentDetail = (student_detail_form, step) => {
    const student_detail = {
        special_skill: student_detail_form.special_skill,
        national_id: student_detail_form.national_id,
        gender: student_detail_form.gender,
        prefix_id: student_detail_form.prefix_th,
        name_th: student_detail_form.name_th,
        name_en: student_detail_form.name_en,
        surname_th: student_detail_form.surname_th,
        surname_en: student_detail_form.surname_en,
        birthday: student_detail_form.birthday,
        phone_number: student_detail_form.phone_number,

        ethnicity: student_detail_form.ethnicity,
        nationality: student_detail_form.nationality,
        religion: student_detail_form.religion,
        student_year: student_detail_form.student_year,
        program: student_detail_form.program,
        register_plan_id: student_detail_form.register_plan_id,
        student_img: student_detail_form.student_img_body || null
    };
    if (step == 5) {
        student_detail.nickname_th = student_detail_form.nickname_th;
        student_detail.nickname_en = student_detail_form.nickname_en;
        student_detail.relatives_count = Number(
            student_detail_form.relatives_count
        );
        student_detail.relatives_index = Number(
            student_detail_form.relatives_index
        );
        student_detail.birth_hospital = student_detail_form.birth_hospital;
        if (
            student_detail.relatives_count == 0 &&
            student_detail.relatives_index == 0
        ) {
            student_detail.has_relatives = false;
        } else {
            student_detail.has_relatives = true;
        }
        student_detail.hospital_province =
            student_detail_form.hospital_province;
    }

    return student_detail;
};

const setStudentOtherDetail = (student_other_detail_form, step) => {
    let student_other_detail = {
        former_school_name: student_other_detail_form.former_school_name,
        former_school_province:
            student_other_detail_form.former_school_province,
        former_school_district:
            student_other_detail_form.former_school_district,
        former_school_GPAX: student_other_detail_form.former_school_GPAX,
        former_school_last_student_year:
            student_other_detail_form.former_school_last_student_year,
    };
    if (step == 5) {
        const student_other_detail_step5 = {
            weight: student_other_detail_form.weight,
            height: student_other_detail_form.height,
            blood_type: student_other_detail_form.blood_type,
            medical_condition: student_other_detail_form.medical_condition,
            drug_allergy: student_other_detail_form.drug_allergy,
            regular_medication: student_other_detail_form.regular_medication,
        };

        student_other_detail = {
            ...student_other_detail,
            ...student_other_detail_step5,
        };
    }
    return student_other_detail;
};

const setStudentAddress = (student_address_detail_form, step) => {
    const student_address_detail = {
        national_address: student_address_detail_form.national_address,
        national_moo: student_address_detail_form.national_moo,
        national_soi: student_address_detail_form.national_soi,
        national_road: student_address_detail_form.national_road,
        national_province: student_address_detail_form.national_province,
        national_district: student_address_detail_form.national_district,
        national_subdistrict: student_address_detail_form.national_subdistrict,
        national_postal_code: student_address_detail_form.national_postal_code,
    };
    if (step == 5) {
        student_address_detail.current_address =
            student_address_detail_form.current_address;
        student_address_detail.current_moo =
            student_address_detail_form.current_moo;
        student_address_detail.current_soi =
            student_address_detail_form.current_soi;
        student_address_detail.current_road =
            student_address_detail_form.current_road;
        student_address_detail.current_province =
            student_address_detail_form.current_province;
        student_address_detail.current_district =
            student_address_detail_form.current_district;
        student_address_detail.current_subdistrict =
            student_address_detail_form.current_subdistrict;
        student_address_detail.current_postal_code =
            student_address_detail_form.current_postal_code;
        student_address_detail.accommodation_type =
            student_address_detail_form.accommodation_type;
        student_address_detail.distance_home_to_school = Number(
            student_address_detail_form.distance_home_to_school
        );
        student_address_detail.transportation_type =
            student_address_detail_form.transportation_type;
        student_address_detail.is_same_address =
            student_address_detail_form.is_same_address;
    }
    return student_address_detail;
};

const setStudentParent = (
    student_parent_form,
    student_parent_address,
    step
) => {
    const mother = student_parent_form.mother;
    const father = student_parent_form.father;
    const guardian = student_parent_form.guardian;

    const student_parent = {
        mother: {
            prefix_id: mother.prefix_id,
            name_th: mother.name_th,
            name_en: mother.name_en,
            surname_th: mother.surname_th,
            surname_en: mother.surname_en,
            phone_number: mother.phone_number,
            career: mother.career,
            position: mother.position,
            work_place: mother.work_place,
            prefix_th: mother.prefix_th,
            prefix_en: mother.prefix_en,
            is_guardian: student_parent_form.checkMother,
        },
        father: {
            prefix_id: father.prefix_id,
            name_th: father.name_th,
            name_en: father.name_en,
            surname_th: father.surname_th,
            surname_en: father.surname_en,
            phone_number: father.phone_number,
            career: father.career,
            position: father.position,
            work_place: father.work_place,
            prefix_th: father.prefix_th,
            prefix_en: father.prefix_en,
            is_guardian: student_parent_form.checkFather,
        },
        guardian: {
            prefix_id: guardian.prefix_id,
            name_th: guardian.name_th,
            name_en: guardian.name_en,
            surname_th: guardian.surname_th,
            surname_en: guardian.surname_en,
            phone_number: guardian.phone_number,
            career: guardian.career,
            position: guardian.position,
            work_place: guardian.work_place,
            prefix_th: guardian.prefix_th,
            prefix_en: guardian.prefix_en,
            is_guardian: true,
        },
    };

    student_parent.student_parent_detail = {
        family_status: student_parent_form.student_parent_detail.family_status,
        is_siblings_study_together: student_parent_form.student_parent_detail.is_siblings_study_together,
        siblings_name: student_parent_form.student_parent_detail.siblings_name,
        siblings_surname: student_parent_form.student_parent_detail.siblings_surname,
        siblings_grade: student_parent_form.student_parent_detail.siblings_grade,
        siblings_house: student_parent_form.student_parent_detail.siblings_house,
    };

    if (step == 5) {
        // detail

        const father_step5 = {
            email: father.email,
            salary: father.salary,
            parent_type: father.parent_type,
            ...student_parent_address.father,
        };
        const mother_step5 = {
            email: mother.email,
            salary: mother.salary,
            parent_type: mother.parent_type,
            ...student_parent_address.mother,
        };
        const guardian_step5 = {
            email: guardian.email,
            salary: guardian.salary,
            parent_type: guardian.parent_type,
            ...student_parent_address.guardian,
        };
        // address

        student_parent.mother = { ...student_parent.mother, ...mother_step5 };
        student_parent.father = { ...student_parent.father, ...father_step5 };
        student_parent.guardian = {
            ...student_parent.guardian,
            ...guardian_step5,
        };

        student_parent.student_parent_detail = { ...student_parent.student_parent_detail,
            student_allowance_by: student_parent_form.student_parent_detail.student_allowance_by,
            update: "update"
        };
    } else {
        student_parent.student_parent_detail = { ...student_parent.student_parent_detail,
            update: "new",
        };
    }
    return student_parent;
};
</script>

<style>
#yellow-chip {
    border-radius: 10px;
}
</style>
